<template>
    <tr class="rate-history-row rate-history-row-text">
        <slot name="prepend-cells"></slot>
        <td colspan="16">
            <div class="row">
                <div class="col-lg-2"></div>
                <div v-bind:class="{'col-lg-5': true, 'field-updated': isFieldUpdated('fee_conditions')}">
                    <label>Fees and Conditions</label>
                    <div v-if="feeConditionsVisible" v-html="rate.fee_conditions"></div>
                    <span v-else>{{strippedFeeConditions}}...</span>
                    <a v-on:click="toggleFeeConditions" href="#">
                        <template v-if="feeConditionsVisible">[Less]</template>
                        <template v-else>[more]</template>
                    </a>
                </div>
                <div v-bind:class="{'col-lg-5': true, 'field-updated': isFieldUpdated('internal_notes')}">
                    <label>Internal Notes</label>
                    <div v-if="internalNotesVisible" v-html="rate.internal_notes"></div>
                    <span v-else>{{strippedInternalNotes}}...</span>
                    <a v-on:click="toggleInternalNotes" href="#">
                        <template v-if="internalNotesVisible">[Less]</template>
                        <template v-else>[more]</template>
                    </a>
                </div>
            </div>
        </td>
        <slot name="append-cells"></slot>
    </tr>
</template>

<script>
export default {
    name: 'rate-list-text-history-row',
    props: {
        rate: {
            type: Object
        },
    },
    data () {
        return {
            feeConditionsVisible: false,
            internalNotesVisible: false,
        }
    },
    computed: {
        strippedFeeConditions () {
            return this.stripHtml(this.rate.fee_conditions).substring(0, 40);
        },
        strippedInternalNotes () {
            return this.stripHtml(this.rate.internal_notes).substring(0, 40);
        }
    },
    methods: {
        isFieldUpdated(fieldname) {
            const properties = this.rate.properties || {};
            const old = properties.old || false;
            if (!old) {
                return false;
            }
            const current = properties.attributes || {};
            
            return old[fieldname] !== current[fieldname];
        },
        toggleFeeConditions (e) {
            e.preventDefault();
            this.feeConditionsVisible = !this.feeConditionsVisible;
        },
        toggleInternalNotes (e) {
            e.preventDefault();
            this.internalNotesVisible = !this.internalNotesVisible;
        },
        stripHtml (html) {
            // solution provided from https://stackoverflow.com/questions/44371639/how-to-remove-html-tags-from-rendered-text
            var div = document.createElement("div");
            div.innerHTML = html;
            var text = div.textContent || div.innerText || "";
            return text;
        }
    }
}
</script>
